import type { AuthChangeEvent, Session } from "@supabase/supabase-js"
import { useEffect } from "react"

import { useSupabase } from "./use-supabase"

export type UseAuthStateChangesProps = {
  onEvent?: (event: AuthChangeEvent, session: Session | null) => void
}

export function useAuthStateChanges({
  onEvent,
}: UseAuthStateChangesProps = {}) {
  const supabase = useSupabase()

  useEffect(() => {
    const { data } = supabase.auth.onAuthStateChange((event, session) => {
      // Run in timeout to avoid creating potential deadlocks
      // https://supabase.com/docs/reference/javascript/auth-onauthstatechange
      setTimeout(() => onEvent?.(event, session), 0)
    })

    return () => {
      data.subscription.unsubscribe()
    }
  }, [supabase, onEvent])
}
